// Shared "soft surface" design language used by the agentic home and the
// onboarding experience: oversized rounded cards, ultra-soft layered shadows,
// and a warm-gray page gradient.

export const SOFT_SURFACE_RADIUS = "32px";

export const SOFT_SURFACE_SHADOW =
  "0px 0px 0px 0.5px rgba(0,0,0,0.04), 0px 0px 2px 0px rgba(0,0,0,0.08), 0px 4px 8px 0px rgba(0,0,0,0.04)";

export const SOFT_SURFACE_HOVER_SHADOW =
  "0px 0px 0px 0.5px rgba(0,0,0,0.04), 0px 2px 4px rgba(0,0,0,0.06), 0px 10px 20px -4px rgba(0,0,0,0.10)";

/** Layered gradient applied to the full page background. */
export const SOFT_PAGE_BACKGROUND =
  "linear-gradient(0deg, rgba(171, 178, 186, 0.2) 0%, rgba(200, 193, 197, 0.2) 38.4%, rgba(211, 203, 202, 0.2) 55.5%, rgba(215, 210, 209, 0.2) 100%), #f5f5f5";

// Display typography shared by the agentic home greeting and the onboarding page
// title so the two surfaces stay in sync.
export const AGENTIC_DISPLAY_TITLE_PROPS = {
  fontSize: "40px",
  lineHeight: "48px",
  fontWeight: "medium",
  letterSpacing: "-0.3px",
  color: "text.tertiary",
} as const;

export const AGENTIC_DISPLAY_SUBTITLE_PROPS = {
  fontSize: "16px",
  lineHeight: "24px",
  fontWeight: "normal",
  color: "text.disabled",
} as const;
